import React from 'react'
import { FormFeedback, FormGroup, Label } from 'reactstrap'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Select from 'react-select'

import { withTranslation } from 'react-i18next'

import FormInputField from '../../../components/FormInputField'
import PageLoader from '../../../components/PageLoader'

class Step1 extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      noSelectedLanguages: false
    }
  }

  hideNameAsChecking() {
    this.nameField.hideBusy()
  }

  showNameAsChecking() {
    this.nameField.showAsBusy()
  }

  showNameAsInvalid(message = null) {
    this.nameField.showAsInvalid(message)
  }

  showLocalesAsInvalid() {
    this.setState({
      noSelectedLanguages: true
    })
  }

  showLocalesAsValid() {
    this.setState({
      noSelectedLanguages: false
    })
  }

  render() {
    const {
      localeList,
      locales,
      name,
      onChange,
      onLocalesSelect,
      onNameFieldBlur,
      t
    } = this.props

    const { noSelectedLanguages } = this.state

    if (localeList === null) {
      return (
        <PageLoader message={t('ProjectCreationModal.Step1.messages.fetchingData')} />
      )
    }

    const noOptionsMessage = () => (
      <p>
        {t('labels.noOptions')}
        <Link
          className="text-secondary font-weight-bold"
          name="create-locales"
          to="/locales"
        >
          {t('labels.noOptionsLink')}
        </Link>
      </p>
    )

    return (
      <>
        <FormInputField
          inputId="name"
          inputName="name"
          inputType="text"
          labelText={t('fields.name')}
          onChange={(event) => onChange(event)}
          onBlur={() => onNameFieldBlur()}
          inputPlaceholder={t('fields.namePlaceholder')}
          ref={(component) => { this.nameField = component }}
          value={name}
        />
        <FormGroup className="position-relative">
          <Label for="locales">
            {t('fields.locales')}
          </Label>
          <Select
            id="locales"
            isMulti
            onChange={(locale) => onLocalesSelect(locale)}
            openMenuOnFocus
            options={localeList}
            noOptionsMessage={() => noOptionsMessage()}
            placeholder={t('fields.localesPlaceholder')}
            value={locales}
          />
          {noSelectedLanguages && (
            <FormFeedback className="d-block z-0" tooltip>
              {t('errors.required_field', { ns: 'commons' })}
            </FormFeedback>
          )}
        </FormGroup>
      </>
    )
  }
}

Step1.propTypes = {
  localeList: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  locales: PropTypes.arrayOf(PropTypes.object),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onLocalesSelect: PropTypes.func.isRequired,
  onNameFieldBlur: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

Step1.defaultProps = {
  localeList: null,
  locales: null
}

export default withTranslation(['ProjectsPage', 'commons'], { withRef: true })(Step1)
